import React from 'react';
import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';

import { DistanceField } from '@paragon/material';

import { setInsertionRunCalculation, setInsertionRunSpacing } from '../../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import InsertionPanelContainer from '../InsertionPanelContainer';

export function RunInsertionSubPanel() {
  const dispatch = useAppDispatch();
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);

  if (insertingObjectInfo?.type !== 'trussEnvelopeRun') return null;

  return (
    <InsertionPanelContainer hideSubmitButton>
      <Box sx={{ padding: 1, marginBottom: 2 }}>
        <Typography align="center" variant="h5" sx={{ marginBottom: 2 }}>
          Envelope Run Creation
        </Typography>

        <Stack direction="column" spacing={1}>
          <FormControlLabel
            label="Calculate Envelopes"
            control={
              <Checkbox
                checked={insertingObjectInfo.data.calculateEnvelopes}
                onChange={(_, checked) => {
                  dispatch(setInsertionRunCalculation(checked));
                }}
              />
            }
          />

          <DistanceField
            label="Envelope Spacing"
            value={insertingObjectInfo.data.spacing}
            onSubmit={(spacing) => {
              dispatch(setInsertionRunSpacing(spacing));
            }}
          />
        </Stack>
      </Box>
    </InsertionPanelContainer>
  );
}
